"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TempFilesService = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var TempFilesService = exports.TempFilesService = /*#__PURE__*/(0, _createClass2["default"])(function TempFilesService() {
  (0, _classCallCheck2["default"])(this, TempFilesService);
});
(0, _defineProperty2["default"])(TempFilesService, "publish", function (_ref) {
  var token = _ref.token,
    condo = _ref.condo,
    formData = _ref.formData;
  return _Api["default"].withAuth(token).post("/temp/files", formData, {
    params: {
      condo: condo
    }
  });
});